export const reportNames = Object.freeze({
  simDecisionAnalyticsValue: "simDecisionAnalytics",
  rawDataVersionOfSimSummary: "rawDataVersionOfSimSummary",
  mceeResult: "mceeResult",
  recordedResponseTrackReport: "recordedResponseTrackReport",
  cohortParticipationInsightsReport: "Cohort Participation Insights Report",
  simsFeedBackReport: "Sims Feedback",
  clientSummaryReport: "AI Client Summary Report",
  onDemandProfessionalStandardSummaryReport: "Professional Standard Summary Report (On-Demand)",
  monthlySnapshotProfessionalStandardSummaryReport: "Professional Standard Summary Report (Monthly Snapshot)",
  onDemandCaepSimulationSummaryReport: "CAEP Standard Summary Report (On-Demand)",
  monthlySnapshotCaepSimulationSummaryReport: "CAEP Standard Summary Report (Quadrimestral Snapshot)",
  onDemandAaqepSimulationSummaryReport: "AAQEP Standard Summary Report (On-Demand)",
  quadrimestralSnapshotAaqepSimulationSummaryReport: "AAQEP Standard Summary Report (Quadrimestral Snapshot)",
  onDemandNelpPselStandardSummaryReport: "NELP & PSEL Standard Summary Report (On-Demand)",
  quadrimestralSnapshotNelpPselStandardSummaryReport: "NELP & PSEL Standard Summary Report (Quadrimestral Snapshot)",
  accessCodesUsedByAccountValue: "access-codes-used-by-account",
});

export const feildSelectionMessage = Object.freeze({
  selectEmails: "Please Select Emails.",
  selectSimulations: "Please Select Simulations.",
  selectReportType: "Please Select Report Type.",
  selectAccounts: "Please Select Accounts.",
  selectCohort: "Please Select Cohort.",
  accountSingeSelect: "Please Select Account.",
  filter: "Please Select at least one Filter.",
  selectMonthYear: "Please select month and year.",
  invalidMonthYear: "Invalid month/year",
  futureMonthYear: "Month and year cannot be in the future.",
  selectPeriod: "Please select a reporting period.",
});
